import React, { useState } from "react";
import { createUserWithEmailAndPassword } from "firebase/auth";
import { setDoc, doc, serverTimestamp } from "firebase/firestore";
import { auth } from "../../firebase";
import { db } from "../../firebase";
import { Link, useNavigate } from "react-router-dom";

function RegisterScreen() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleRegister = async (e) => {
    e.preventDefault();
    setError("");

    try {
      // 1. Create the user with Firebase Auth
      const userCredential = await createUserWithEmailAndPassword(auth, email, password);
      const user = userCredential.user;

      // 2. Set up demo data IDs
      const demoClubId = `demoClub_${user.uid}`;
      const demoTeamId = `demoTeam_${user.uid}`;
      const demoGameId = `demoGame_${user.uid}`;

      // 3. Demo squad (girls' names)
      const demoSquad = [
        { playerId: "p1", name: "Alice", position: "" },
        { playerId: "p2", name: "Beth", position: "" },
        { playerId: "p3", name: "Chloe", position: "" },
        { playerId: "p4", name: "Daisy", position: "" },
        { playerId: "p5", name: "Ella", position: "" },
        { playerId: "p6", name: "Freya", position: "" },
        { playerId: "p7", name: "Grace", position: "" },
        { playerId: "p8", name: "Hannah", position: "" },
        { playerId: "p9", name: "Isla", position: "" }
      ];

      // 4. Demo starting lineup and subs
      const demoStartingLineup = [
        { playerId: "p1", name: "Alice", position: "GS" },
        { playerId: "p2", name: "Beth", position: "GA" },
        { playerId: "p3", name: "Chloe", position: "WA" },
        { playerId: "p4", name: "Daisy", position: "C" },
        { playerId: "p5", name: "Ella", position: "WD" },
        { playerId: "p6", name: "Freya", position: "GD" },
        { playerId: "p7", name: "Grace", position: "GK" }
      ];
      const demoSubs = [
        { playerId: "p8", name: "Hannah" },
        { playerId: "p9", name: "Isla" }
      ];

      // 5. Create User doc in Firestore
      await setDoc(doc(db, "users", user.uid), {
        email: user.email,
        displayName: "", // Optionally add name field to your form
        role: "coach",
        plan: "free",
        clubId: demoClubId,
        teamId: demoTeamId,
        createdAt: serverTimestamp(),
      });
      // 6. Create Demo Club
      await setDoc(doc(db, "clubs", demoClubId), {
        clubId: demoClubId,
        clubName: "Demo Club",
        logoUrl: "",
        createdBy: user.uid,
      });
      // 7. Create Demo Team
      await setDoc(doc(db, "teams", demoTeamId), {
        teamId: demoTeamId,
        teamName: "Demo Team",
        clubId: demoClubId,
        coachId: user.uid,
        squad: demoSquad,
        defaultPositions: ["GS", "GA", "WA", "C", "WD", "GD", "GK"]
      });
      // 8. Create Demo Match/Game
      await setDoc(doc(db, "games", demoGameId), {
        gameId: demoGameId,
        teamId: demoTeamId,
        clubId: demoClubId,
        matchType: "League",
        quarterLength: 12,
        quarters: 4,
        date: new Date().toISOString().split("T")[0], // today's date as YYYY-MM-DD
        time: "16:00",
        opponent: "Demo Opponent",
        startingLineup: demoStartingLineup,
        subs: demoSubs,
        status: "not started",
        homeScore: 0,
        awayScore: 0,
        stats: {},
        events: [],
        createdBy: user.uid
      });
      // Redirect to home/dashboard (update as needed)
      navigate("/dashboard");

    } catch (err) {
      setError(err.message);
      console.error("Registration error:", err);
    }
  };

  return (
    <div style={{ padding: 24 }}>
      <h2>Register</h2>
      <form onSubmit={handleRegister}>
        <div>
          <input
            type="email"
            placeholder="Email"
            value={email}
            autoComplete="email"
            onChange={(e) => setEmail(e.target.value)}
            required
            style={{ marginBottom: 8, padding: 8, width: 240 }}
          />
        </div>
        <div>
          <input
            type="password"
            placeholder="Password"
            value={password}
            autoComplete="new-password"
            onChange={(e) => setPassword(e.target.value)}
            required
            style={{ marginBottom: 8, padding: 8, width: 240 }}
          />
        </div>
        {error && <div style={{ color: "red", marginBottom: 8 }}>{error}</div>}
        <button type="submit" style={{ padding: 8, width: 100 }}>Sign Up</button>
      </form>
      <p>
        Already have an account? <Link to="/login">Log in</Link>
      </p>
    </div>
  );
}

export default RegisterScreen;
